// extracted by mini-css-extract-plugin
module.exports = {"container":"normal_container__lmhsP","iconList":"normal_iconList__8ksnF","icon":"normal_icon__Xz9C0","moreIcons":"normal_moreIcons__V4j7U","amount":"normal_amount__HnJ6C"};